export default __webpack_public_path__ + "static/media/homeopathy_0.cedf42bb.jpg";